import {
	GetWorkerProgramDetailResponse,
	GetWorkerProgramListResponse,
} from '@/services';
import { formatDate, map } from '@/utils';

import { isNotNilOrEmpty } from 'ramda-adjunct';

export const formatWorkerProgramStatusDetail = (
	input: GetWorkerProgramDetailResponse
) => {
	return {
		...input,
		startDate: formatDate(input.startDate),
		endDate: formatDate(input.endDate),
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatWorkerProgramStatusListItem = (
	input: GetWorkerProgramListResponse['content'][number]
) => {
	return {
		...input,
		id: input?.programId,
		programStartDate: formatDate(input.programStartDate),
		programEndDate: formatDate(input.programEndDate),
		programRegistDt: formatDate(input.programRegistDt),
		programUpdateDt: formatDate(input.programUpdateDt),
	};
};

export const formatWorkerProgramStatusList = (
	input: GetWorkerProgramListResponse['content']
) => {
	return map(input, formatWorkerProgramStatusListItem);
};

export const formatWorkerProgramStatusExcelList = (
	input: GetWorkerProgramListResponse['content']
) => {
	return map(input, (item) => {
		const thisKeys: (keyof typeof item)[] = [
			'programFarmCnt',
			'programAgriculturalCoCnt',
			'programPublicFranchiseCnt',
			'programFishingCnt',
			'programCorporateFishingCnt',
			'programFranchiseCnt',
		];

		const peopleCountKeys: (keyof typeof item)[] = [
			'programMouApplicantCnt',
			'programMarriageImmigrantsCnt',
			'programForeignersStayingCnt',
			'programReEntryCnt',
			'programApplicantCnt',
			'programWorkplaceChangeCnt',
			'programUnauthorizedDepartureCnt',
			'programExtensionStayCnt',
		];

		const formattedDataKeys = (data: (keyof typeof item)[], unit?: string) =>
			data.reduce(
				(acc, key) => {
					if (item[key] !== undefined) {
						acc[key] = isNotNilOrEmpty(item[key]) ? `${item[key]}${unit}` : '';
					}
					return acc;
				},
				{} as { [key: string]: string }
			);

		return {
			...formatWorkerProgramStatusListItem(item),
			...formattedDataKeys(thisKeys, '개'),
			...formattedDataKeys(peopleCountKeys, '명'),
		};
	});
};
